import Controller from "csi/action/Controller";
import { resolveNodesWithDependencies } from "csi/service/nodeService";
import { routerStore } from "csi/state/rootStore";
import New from "csi/table/New";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import FoodSamplesForm from "./FoodSamplesForm";
import FormulatedMaterialSamplesForm from "./FormulatedMaterial/FormulatedMaterialSamplesForm";
import { FormulatedProductSampleFormMixin } from "./FormulatedProductSampleFormMixin";

const FACTORY = "Factory";
const SUPPLIER = "Supplier";

const NewFoodSourceSamples = declare(New, {
	// Boolean: default New controller only adds one node - this controller may add many
	bUpdateParent: false,

	// Boolean: validation is handled explicitly
	bValidate: false,

	// cnl[]: List of samples
	samples: null,

	/**
	 * Add special controller for copy form
	 */
	onCreatePopupDefView: function (defView) {
		if (defView.getTypeNode() === "FoodSample") {
			defView.classController = FoodSamplesForm;
		} else {
			defView.classController = FormulatedMaterialSamplesForm;
		}
	},

	getStringParameters: function () {
		// summary: use return value as parameter to success message
		var cntr = this.samples == null ? 0 : this.samples.length;
		return [cntr];
	},

	getReturnNodeRequest: function (/*String[]*/urlsNew) {
		// summary: add new url to request
		return this.inherited(arguments, [urlsNew.concat(this.samples)]);
	},

	getNewNodes: function () {
		// summary: get nodes resulting from action for postprocessing
		return this.m_cache.getNodes(this.samples);
	},

	/**
	 * @override
	 * initialize product and supplier on samples form (can be overridden)
	 */
	onCreatePopup: function (view) {
		view.setProduct(routerStore.getBreadcrumbNode("Food") || routerStore.getBreadcrumbNode("FormulatedMaterial"));
		const sourceCnl = xml.isValidURL(this.getParent().SupplierFactory) ? this.getParent().SupplierFactory : this.getParent().Supplier;
		view.setSource(sourceCnl, this.getParent().$Name);
	},

	/**
	 * @override
	 * make the source node in cache so that we can get the name through the node
	 */
	async process() {
		const fd = this.m_formData;

		const sources = fd.getFieldValue(FACTORY, true) || fd.getFieldValue(SUPPLIER, true);
		await resolveNodesWithDependencies(sources, ["Child:Factory"], this.m_cache);

		Controller.prototype.process.call(this);
	},

	toWriter: function () {
		// summary: create samples according to form and add to source
		this.samples = (this.popupView as FormulatedProductSampleFormMixin).toWriterSamples(this);
	},

	_canNavigate: function () {
		// summary: disable Save & Go since action can create multiple samples
		return false;
	},
});

export = NewFoodSourceSamples;